import * as React from 'react';
import { Modal, Button } from 'antd';

import './bv-disclaimer-modal.scss'

interface IBVDisclaimerModal {
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    title: string;
    text: string;
}

const BVDisclaimerModal: React.FunctionComponent<IBVDisclaimerModal> = ({ visible, setVisible, title, text }) => {

    const divRef = React.useRef<HTMLDivElement>(null);

    const handleClick = () => {
        setVisible(false);
    };

    React.useEffect(() => {
        if (text && divRef?.current) {
            const notice = document.querySelector(text);
            if (notice) {
                divRef.current.appendChild(notice);
            }
        }

    }, [text, visible])

    return (
        <Modal
            title={
                <div style={{ textAlign: 'center' }}>
                    <div style={{ textTransform: 'uppercase', fontWeight: 600 }}>{title}</div>
                </div>
            }
            width={900}
            visible={visible}
            closable={false}
            style={{ top: 50 }}
            onOk={handleClick}
            footer={
                <div style={{ textAlign: 'center', paddingBlock: '10px' }}>
                    <Button
                        key="agree"
                        type="primary"
                        onClick={handleClick}
                        style={{ paddingInline: '50px' }}
                    >
                        Close
                    </Button>
                </div>
            }
        >
            <div className="privacy-policy-container">
                <div ref={divRef} className='otnotice'></div>
            </div>
        </Modal>
    );
}

export default BVDisclaimerModal;